// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2023 (original work) Open Assessment Technologies SA
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
import config from '@/config';
import { loginGuard } from '@/core/guards/loginGuard';

export const routing = [
    {
        path: [config.routes.login.main],
        guard: loginGuard,
        controller: () => import('./controllers/tenantLogin')
    },
    {
        path: [config.routes.login.session],
        guard: loginGuard,
        controller: () => import('./controllers/sessionLogin.js')
    },
    {
        path: [config.routes.login.withLocale],
        guard: loginGuard,
        controller: () => import('./controllers/tenantLogin')
    },
    {
        path: [config.routes.login.logout],
        controller: () => import('./controllers/logout')
    }
];
